import apiClient from 'services/_infra/apiClient';
import { loginfo } from 'services/_infra/util/apiUsageLogger';
import { tryMsAuthSilent } from 'services/auth/ms.service';

export async function ms_updateRoleLinks(instance, links) {
  loginfo();
  const msRes = await tryMsAuthSilent(instance, ['Group.Read.All']);
  if (!msRes) {
    throw new Error('Could not get MS token');
  }
  try {
    return await apiClient.post(
      '/auth/azure/role-links/batch',
      {
        roleLink: links,
      },
      {
        headers: {
          MsAuth: `Bearer ${msRes.accessToken}`,
        },
      },
    );
  } catch (error) {
    console.error('batchUpdateMsLinkRoles failed.', error);
  }
}

export async function ms_getRoleLinks(instance) {
  loginfo();
  const msRes = await tryMsAuthSilent(instance, ['Group.Read.All']);
  if (!msRes) {
    throw new Error('Could not get MS token');
  }
  try {
    return await apiClient.get('/auth/azure/role-links', {
      headers: {
        MsAuth: `Bearer ${msRes.accessToken}`,
      },
    });
  } catch (error) {
    console.error('getAllMsRoleLinks failed.', error);
  }
}
